import { render, staticRenderFns } from "./selectChildDlg.vue?vue&type=template&id=8a3b8350&scoped=true"
import script from "./selectChildDlg.vue?vue&type=script&lang=js"
export * from "./selectChildDlg.vue?vue&type=script&lang=js"
import style0 from "./selectChildDlg.vue?vue&type=style&index=0&id=8a3b8350&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3b8350",
  null
  
)

export default component.exports